<template>
  <div class="animate__animated animate__fadein animate__delay-0.5s ">
    <div style="width: 100% ;height:auto;margin-top: .1354rem; display: flex; justify-content: space-between;">
      <div>
        <img :src="'https://www.cdjjwang.com/' + this.avatar" alt="" style="width: .7813rem;height: 1.0417rem;">

      </div>

      <div style="width: 2.3438rem;height: 100%;" id="basic">
        <div style="display: flex;margin-bottom: .0729rem; ">
          <div class="title"><img src="../../assets/TjianliHead.png" alt="" style="width: .0729rem;height: .0885rem;">
            <div style="margin-left: .0469rem;">姓名</div>
          </div>
          <div class="answer" style="transform: translateY(-0.026rem);">{{ this.username }}
            <img v-if="this.certification == 2" src="../../assets/Stjianlivip.png" alt="" srcset=""
              style="width: .3125rem;height: .1042rem;transform:translate(.026rem,.026rem)">
          </div>
        </div>
        <div style="display: flex;margin-bottom: .0729rem; ">
          <div class="title">
            <img src="../../assets/TjianliSchool.png" alt="">
            <div>就读高校</div>
          </div>
          <div class="answer">{{ this.university }}
          </div>
        </div>
        <div style="display: flex;margin-bottom: .0729rem; ">
          <div class="title"><img src="../../assets/TjianliXuewei.png" alt="">
            <div style="margin-left: .0469rem;">学历</div>
          </div>
          <div class="answer">{{ this.xueli }}
          </div>
        </div>
        <div style="display: flex;margin-bottom: .0729rem; ">
          <div class="title"><img src="../../assets/TjianliSex.png" alt="">
            <div>性别</div>
          </div>
          <div class="answer">

            {{ sexlist[this.sex] }}
          </div>
        </div>
        <div style="display: flex;margin-bottom: .0729rem; ">
          <div class="title"><img src="../../assets/TjianliZhuanye.png" alt="">
            <div style="margin-left: .0469rem;">专业</div>
          </div>
          <div class="answer">{{ this.major }}</div>
        </div>

        <div style="display: flex;margin-bottom: 0rem; ">
          <div class="title" style="display:flex"><img src="../../assets/TjianliClass.png" alt=""
              style="transform: translateY(.0052rem);">
            <div>授课范围</div>
          </div>
          <div style="width: 1.6938rem;height: auto;display: flex;justify-content: left;flex-wrap: wrap;"
            class="shouke">
            <div v-for="item in  teachitems.filter(item => item !== null)"><img :src="getImageUrl(item)" alt=""><span>{{
          teachitemslist[item]
        }}</span>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div
      style="width: .675rem;height: .125rem;color: rgb(1, 162, 153);font-family: 苹方;font-size: .0938rem;font-weight: 600;line-height: .125rem;letter-spacing: 0rem;text-align: left;margin-top: .0833rem;">
      自我介绍
    </div>
    <div style="width: 3.4167rem;height: .0104rem;background: rgb(1, 162, 153);margin-top: .0208rem;"></div>
    <div class="introTxt">{{ this.selfEvaluation }}</div>


    <div class="introduce">
      <div class="title">
        <img src="../../assets/TjianliJiangbei.png" alt="">
        <div>获奖经历</div>
      </div>
      <div class="introTxt">{{ this.awards }}</div>

      <div class="title">
        <img src="../../assets/TjianliJiaoxue.png" alt="">
        <div>教学经历</div>
      </div>
      <div class="introTxt">{{ this.teachingExperience }}</div>


      <div class="title">
        <img src="../../assets/TjianliZiwo.png" alt="">
        <div>自我评价</div>
      </div>
      <div class="introTxt">{{ comment }}</div>


    </div>
    <div id="course">

      <div class="flex" style="transform: translateY(-.022rem);justify-content: left;">
        <div class="title" style="transform: translateY(.052rem);"><img src="../../assets/TjianliTime.png" alt="">
          <div>授课时间</div>
        </div>
        <div class="answer" style="height: .1771rem; transform: translateY(.052rem);" id=" quyu">
          <span v-for=" item  in  this.studyTimes ">{{ studyTimeslist[item] }}　</span>
        </div>
      </div>
      <!-- <div class="flex" style="width: 2.7083rem;margin-top: .099rem;"> -->
      <div class="flex" style="width: 2.7083rem;">
        <div class="flex" style="justify-content: left;margin: .0833rem 0 .0833rem 0;">
          <div class="title"><img src="../../assets/TjianliLocation.png" alt="">
            <div>授课区域</div>
          </div>
          <div class="answer">
            <span v-for=" item  in  teachAreas ">{{ teachAreaslist[item] }}　</span>
          </div>
        </div>

      </div>
      <div class="flex" style="justify-content: left;margin: .0033rem 0 .0833rem 0;">
        <div class="title"><img src="../../assets/TjianliFangshi.png" alt="">
          <div>辅导方式</div>
        </div>
        <div class="answer">{{ displayLabel }}</div>
      </div>

      <!-- </div> -->
      <div class="flex" style="width: 1.59438rem;">
        <div class="title" style="width: .5583rem;"><img src="../../assets/TjianliMoney.png" alt="">
          <div style="width: .26rem;">课时费</div>
        </div>
        <div class="answer" style="width: 1rem;">{{ money2 }}元/小时至{{ money1 }}元/小时</div>
      </div>
      <div style="position: relative;width: .9rem;margin-left: 2.5rem;" v-if="button[0]">
        <button alt="" @click="jujue" class="button" style="left: 0;" v-if="button[1]">拒绝</button>
        <button alt="" @click="yuyue" style="left: 0.49rem;">{{ button[1] ? '接受' : '预约' }}</button>
      </div>


    </div>

  </div>
</template>

<script>
export default {
  props: {
    cid: {
      type: String,
      default: ''
    },
    tid: {
      type: String,
      default: ''
    },
    button: {
      type: Array,
      default: function () {
        return [true, false];  // 返回一个新的空数组
      }
    },

  },
  data() {
    return {
      username: '',
      certification: '',
      comment: '',
      avatar: '',
      sexlist: ['男', '女'],
      sex: 0,
      major: "",
      money1: 50,
      money2: 100,
      university: '',
      studyTimes: [],
      studyTimeslist: ['周一到周五晚上', '周一到周五全天', '周六上午', '周六下午', '周六晚上', '周日上午', '周日下午', '周日晚上', '寒暑假均可'],
      teachAreaslist: ['锦江区', '金牛区', '武侯区', '青羊区', '成华区', '高新区', '天府新区', '新都区', '郫都区', '双流区', '龙泉驿区', '温江区', '其他', '都江堰', '彭州', '邛崃', '崇州', '简阳', '金堂', '大邑', '蒲江', '新津', '青白江'],
      teachAreas: [],
      selfEvaluation: '',
      awards: '',
      xueli: '',
      teachitemslist: {
        10: '小学全科',
        11: '小学语文',
        12: '小学奥数',
        13: '小学数学',
        14: '小学英语',
        15: '作业辅导',
        20: '初中全科',
        21: '初中语文',
        22: '初中英语',
        23: '初中数学',
        24: '初中物理',
        25: '初中化学',
        30: '高中数学',
        31: '高中语文',
        32: '高中英语',
        33: '高中物理',
        34: '高中化学',
        35: '高中生物',
        36: '高中历史',
        37: '高中政治',
        38: '高中地理',
        40: '法语',
        41: '德语',
        42: '西班牙语',
        43: '日语',
        44: '葡萄牙语',
        45: '韩语',
        50: '音乐',
        51: '美术',
        52: '舞蹈',
        53: '体育',
        54: '体育',
        60: '其他',

      },
      graduate: ['专科', '本科', '硕士', '博士'],
      nianji: ['大一', '大二', '大三', '大四', '硕士在读', '博士在读'],
      teachitems: [],
      teachingExperience: '',
      hash: '',
      isOnline: 0,



    }

  },
  computed: {
    displayLabel() {
      switch (this.isOnline) {
        case null:
          return '不限';
        case 0:
          return '老师上门辅导';
        case 1:
          return '线上辅导';
        default:
          return '';
      }
    }
  },
  methods: {

    submit() {
      for (let key in this.$data) {
        if (this.$data[key] === '' || this.$data[key].length == 0 || this.fanweichecked[0].value.length == 0) {
          console.error(`The ${key} field is empty`);
          this.$message.error('您输入的信息不完整哦~');
          return false;
        }
      }
      this.$router.push('/personteacher/jianlisucces')

    }, getImageUrl(imageName) {
      return require('@/assets/icon/' + imageName + '.png');
    }, yuyue() {
      if (!(this.button[1])) {
        this.$router.push({ path: '/studentyuyueing', hash: '#' + this.hash });
      }
      else {
        this.$http.put('/Api/Parent/Contract/' + this.cid + '/Apply', {}, {
          headers: {
            'Authorization': localStorage.getItem('Authorization')
          }
        }).then(res => {
          console.log(res);

        })
      }

    },
    jujue() {
      this.$http.put('/Api/Parent/Contract/' + this.cid + '/Refuse', {}, {
        headers: {
          'Authorization': localStorage.getItem('Authorization')

        }
      }).then(res => {
        console.log(res);
      })

    }


  }, created() {
    this.hash = this.$router.hash;
    if (this.tid) {
      this.hash = this.tid;
    }
    console.log(this.tid);
    this.$http.get('/Api/Parent/Teacher/' + this.hash, {
      headers: {
        'Authorization': localStorage.getItem('Authorization')
      }
    }).then(res => {
      console.log(res.data.data);
      let alldata = res.data.data;
      this.comment = alldata.comment;
      this.username = alldata.name;
      this.avatar = alldata.avatar;
      this.sex = alldata.gender
      this.major = alldata.major;
      this.university = alldata.university;
      this.studyTimes = alldata.teachingTimes;
      this.teachAreas = alldata.teachingAreas;
      this.money1 = alldata.teachingPriceLowVerified;
      this.money2 = alldata.teachingPriceHighVerified;
      this.teachitems = alldata.teachingItems;
      this.selfEvaluation = alldata.selfEvaluation
      this.awards = alldata.awards
      this.teachingExperience = alldata.teachingExperience
      this.isOnline = alldata.isOnline
      this.certification = alldata.certification
      if (alldata.isCollegeStudent == 0) {
        this.xueli = this.graduate[alldata.graduateEducation]
      }
      else if (alldata.isCollegeStudent == 1) {
        this.xueli = this.nianji[alldata.collegeStudentGrade]
      }
      else if (alldata.isCollegeStudent == 2) {
        this.xueli = '研究生'
      }
    })
  },
}
</script>

<style scoped>
#quyu /deep/ .el-select .el-input__inner {
  height: 34px;
}

/deep/ .el-cascader .el-input .el-input__inner,
/deep/ .el-select .el-input__inner {
  height: 24px;
}

/deep/ .el-cascader .el-input .el-icon-arrow-down,
/deep/ .el-selcet .el-input .el-icon-arrow-down {
  position: relative;
  font-size: 14px;
  width: 24px;
  height: 24px;
}



/deep/ .el-cascader .el-input .el-icon-arrow-down::before,
/deep/ .el-select .el-input .el-icon-arrow-down::before {
  position: absolute;
  top: -5px;
  left: 0;
  width: 100%;
  height: 100%;
}

/deep/ .el-icon-arrow-up:before {
  content: "\E6E1";
  position: absolute;
  top: -7px;
  left: 5px;
}

/deep/ .el-icon-close:before {
  position: absolute;
  content: "\E6DB";
  top: 1px;
  left: 1px;
}


input {
  width: 100%;
  height: 100%;
}

.emptyinput {
  /* input-完整/small/default/无/off/off/off/off/off (style) */
  width: 170px;
  height: 24px;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(220, 223, 230);
  border-radius:
    4px;
  padding-left: 10px;
}


.emptyinput::placeholder {
  color: rgb(168, 171, 178);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.009999999776482582px;
  text-align: left;
  height: 24px;
}

.emptyinput:focus {
  background: rgb(255, 255, 255);
  outline: 1px solid rgb(220, 223, 230);
}



.flex {
  display: flex;
  justify-content: space-between;
}

.time {
  /* 上次更新时间：2023年5月4日20：50 */
  height: 23px;
  color: rgb(48, 49, 51);
  font-family: "PingFang";
  font-size: 18px;
  font-weight: 550;
  line-height: 25px;
  text-align: left;
}


#basic .title img,
#course .title img,
#edu .title img {
  width: 18px;
  height: 18px;
  transform: translateY(4px);
}

#basic .title div,
#course .title div,
#edu .title div {
  /* 姓名 */
  display: inline-block;
  height: 22px;
  width: 90px;
  color: rgb(48, 49, 51);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.009999999776482582px;
  text-align: left;
  margin-left: 6px;
}

#basic .answer,
#course .answer,
#edu .answer,
#basic .answer input,
#course .answer input,
#edu .answer input {
  /* 18100000000 */
  height: 22px;
  color: rgb(96, 98, 102);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.009999999776482582px;
  text-align: left;
  padding-top: 2px;
}

#basic /deep/ .el-radio__input.is-checked+.el-radio__label {
  color: #606266;
}

#basic /deep/ .el-radio__input.is-checked .el-radio__inner {
  background: rgb(1, 162, 153);
  border: 4px solid rgb(1, 162, 153);
}

#basic /deep/ .el-radio {
  margin-right: 15px;
}

.el-radio-group {
  margin-top: 5px;
}

.fanwei {
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
}

.fanwei img {
  margin-left: 15px;
  margin-bottom: 12px;
}

.introduce .title {
  height: 28px;
  display: flex;
  position: relative;
}

.introTxt {
  width: 656px;
  padding: 12px;
  height: auto;
  box-sizing: border-box;
  color: rgb(96, 98, 102);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
}

.introduce .title::after {
  content: '';
  position: absolute;
  width: 640px;
  height: 1px;
  top: 26px;
  background: rgba(0, 0, 0, 0.15);
}

.introduce .title img {
  width: 18px;
  height: 18px;
  transform: translateY(3px);
}

.introduce .title div {
  /* 获奖经历 */
  height: 22px;
  color: rgb(48, 49, 51);
  font-family: 苹方;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  margin-left: 3px;
}

#course th {
  width: 40px;
  height: 40px;
  color: rgb(96, 98, 102);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.009999999776482582px;
  text-align: center;


}

table {
  border-collapse: collapse;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
  margin-top: 10px;
  margin-left: 21px;
}

#course tr {
  border: none;
  width: 40px;
  height: 36px;
  color: rgb(96, 98, 102);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.009999999776482582px;
  text-align: center;

}

#course input {
  height: 30px;
  width: 30px;
  border-radius: 14px;
}

.checkbox {
  position: relative;
  display: inline-block;
  width: 14px;
  height: 14px;
  margin-right: 10px;
}

.checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkmark {
  position: absolute;
  top: 2px;
  left: 6px;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  background-color: transparent;
  border: none;
}

.checkbox input:checked+.checkmark {
  background-color: #01A299;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox input:checked+.checkmark:after {
  display: block;
}

.checkmark:after {
  left: 5px;
  top: 2px;
  width: 3px;
  height: 6px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.shouke div {
  background: url('../../assets/subjectbg.png');
  width: 95px;
  height: 28px;
  background-size: 100% 100%;
  box-sizing: border-box;
  padding-top: 3px;
  padding-left: 4px;
  margin-bottom: 9px;
  display: flex;
  margin-right: 10px;
}


.shouke div img {
  width: 22px;
  height: 22px;
}

.shouke div span {
  /* 高中数学 */
  display: inline-block;
  width: 76px;
  height: 20px;
  color: rgb(1, 162, 153, .7);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  margin-left: 1px;
}

button {
  position: absolute;
  padding-left: 20px;
  padding-right: 20px;
  width: auto;
  height: 32px;
  background: rgb(1, 162, 153);
  border-radius: 4px;
  border: none;
  /* Small Button */
  color: rgb(255, 254, 254);
  font-family: Microsoft YaHei;
  font-size: 13px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: center;
}

.button {
  padding-left: 20px;
  padding-right: 20px;
  width: auto;
  height: 32px;
  background: rgba(128, 202, 201, 0.2);
  border: 1px solid rgb(1, 149, 146);
  border-radius: 4px;
  color: #019592;
  font-family: Microsoft YaHei;
  font-size: 13px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/layout/Slookteacherjianli.vue